module.exports = __webpack_public_path__ + "static/survicate-e8d711ebbbaf04d030b8850edd7da7b2.png";